import React, { Component } from "react";

import FullScreen from "COMPONENTS/FullScreen/FullScreen";
import { connect } from "react-redux";

import {
  selectSessionKey,
  selectCurrentParticipantUniqueId,
  getIsFullScreenV2
} from "REDUX/Selector/SessionSelector";

import { selectUniqueId, getUserRole } from "../../Routes/selectors";

export class FullScreenContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      zIndexSubDiv: 0,
      zIndexZoomOutButton: 0,
    }
  }

  getZIndexSubMax() {
    let currentMax = -1;
    this.props.subTargets.map((target,index) => {
      const max = target.getMaxZIndex();
      if ( currentMax < max ) currentMax = max;
    }); 
    return currentMax;
  }

  componentDidMount() {
    if ( this.props.mainTarget ) {
      this.setState({
        zIndexZoomOutButton: this.props.mainTarget.getMaxZIndex(),
      });
    }
  }

  componentDidUpdate(prevProps) {
    if ( ( this.props.mainTarget && !prevProps.mainTarget ) ||
      (this.props.mainTarget && this.props.mainTarget !== prevProps.mainTarget ) ){
      const zIndexMain = this.props.mainTarget.getMaxZIndex();
      const zIndexSubMax = this.getZIndexSubMax();
      if( this.state.zIndexSubDiv < zIndexMain ) {
        this.setState({
          zIndexSubDiv: zIndexMain
        });
      }
      const zIndexZoomOutButton = zIndexMain > zIndexSubMax ? zIndexMain : zIndexSubMax;
      if( this.state.zIndexZoomOutButton < zIndexZoomOutButton ) {
        this.setState({
          zIndexZoomOutButton: zIndexZoomOutButton
        });
      }
    } else if(!this.props.mainTarget && prevProps.mainTarget) {
      this.setState({
        zIndexSubDiv: 0
      });
    }
    if ( this.props.subTargets !== prevProps.subTargets ) {
      const zIndexSubMax = this.getZIndexSubMax();
      if( this.state.zIndexZoomOutButton < zIndexSubMax ) {
        this.setState({
          zIndexZoomOutButton: zIndexSubMax
        });
      }
    }
  }

  render() {

    return (
      <div id="fullScreenV2Container" className="fullScreenV2Container">
        <FullScreen
          isFullScreen={this.props.isFullScreen}
          toggleScreenZoomOut={this.props.toggleScreenZoomOut}
          target={this.props.mainTarget}
          isMain={true}
          zIndexZoomOutButton={this.state.zIndexZoomOutButton + 2}
          switchMainTarget={undefined}
        />
        {
          this.props.subTargets.length > 0 &&
          <div id="fullScreenV2SubTargets" className="fullScreenV2SubTargets" style={{zIndex: this.state.zIndexSubDiv + 1}}>
            {
              this.props.subTargets.map((target,index) => {
                { 
                  return (
                    <FullScreen
                      isFullScreen={this.props.isFullScreen}
                      toggleScreenZoomOut={this.props.toggleScreenZoomOut}
                      target={target}
                      isMain={false}
                      index={index}
                      key={"fullScreenV2SubTargetKey"+index}
                      switchMainTarget={this.props.switchMainTarget}
                    />
                  )
                }
              })
            }
          </div>
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    currentParticipantUniqueId: selectCurrentParticipantUniqueId(state),    
    sessionKey: selectSessionKey(state),
    uniqueId: selectUniqueId(state),
    userRole: getUserRole(state),
    isFullScreen: getIsFullScreenV2(state),
  };
};

export default connect(
  mapStateToProps,
)(FullScreenContainer);
